var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lgrid-middle-noWrap" },
    [
      _vm._l(_vm.contextualFilters, function (filter, filterName) {
        return _vm._l(filter, function (value, key) {
          return _c(
            "button",
            {
              key: filterName + key,
              staticClass: "lcol-auto context-filter lgrid-middle-noWrap",
              on: {
                click: function ($event) {
                  return _vm.deleteStore(filterName, value.id)
                },
              },
            },
            [
              _c("span", {
                staticClass: "label lgrid-middle-noGutter",
                domProps: { innerHTML: _vm._s(value.name) },
              }),
              _c("i", { staticClass: "dsio-close" }),
            ]
          )
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }